import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-right" }

import {h, ref, reactive, watch, computed, onMounted} from 'vue';
import {useRouter} from "vue-router";
import {
  SlackOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
  AppstoreOutlined, UserOutlined
} from '@ant-design/icons-vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'NavView',
  setup(__props) {

const current = ref<string[]>(['1']);
const router = useRouter()
const state = reactive({
  collapsed: false,
  selectedKeys: ['1'],
  openKeys: ['sub1'],
  preOpenKeys: ['sub1'],
});

onMounted(()=>{
  console.log("进入nav-->")
})

const menus = ref<any[]>([
  {key: '1', label: '股票管理', title: '股票管理',
    children: [
      {key: '10', label: '股票列表', title: '股票列表',path: '/stock', icon: () => h(SlackOutlined)},
      {key: '11', label: '板块分析', title: '板块分析',path: '/industry', icon: () => h(SlackOutlined)},
      {key: '12', label: '财务数据', title: '财务数据',path: '/financial', icon: () => h(SlackOutlined)},
      {key: '13', label: '币列表', title: '币列表', path: '/symbol', icon: () => h(SlackOutlined)},
    ],
    icon: () => h(AppstoreOutlined),
  },
])

const headerMenus = computed(()=>{
  return menus.value?.map(item=>{
    return {...item, children: null}
  })
})

const leftMenus = computed(()=>{
  return menus.value?.find(item=>item.key===current.value[0]).children
})

const clickMenu = ({item}: {item: any}) =>{
  if(item.path){
    router.push(item.path)
  }
}

watch(
    () => state.openKeys,
    (_val, oldVal) => {
      state.preOpenKeys = oldVal;
    },
);


return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "logo" }, [
          _createElementVNode("img", {
            src: "/logo.svg",
            height: "30",
            width: "30",
            style: {"margin-right":"5px"}
          }),
          _createTextVNode(" 量化系统 ")
        ])
      ], -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_a_menu, {
          selectedKeys: current.value,
          "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
          mode: "horizontal",
          items: headerMenus.value
        }, null, 8, ["selectedKeys", "items"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(UserOutlined)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"margin-left":"10px"} }, "杨茂奇", -1))
      ])
    ]),
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_sider, {
          collapsed: state.collapsed,
          "onUpdate:collapsed": _cache[4] || (_cache[4] = ($event: any) => ((state.collapsed) = $event)),
          trigger: null,
          collapsible: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu, {
              openKeys: state.openKeys,
              "onUpdate:openKeys": _cache[1] || (_cache[1] = ($event: any) => ((state.openKeys) = $event)),
              selectedKeys: state.selectedKeys,
              "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((state.selectedKeys) = $event)),
              mode: "inline",
              "inline-collapsed": state.collapsed,
              items: leftMenus.value,
              onClick: clickMenu
            }, null, 8, ["openKeys", "selectedKeys", "inline-collapsed", "items"]),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (state.collapsed = !state.collapsed)),
              class: "sider-collapsed"
            }, [
              _createElementVNode("a", null, [
                (!state.collapsed)
                  ? (_openBlock(), _createBlock(_unref(MenuFoldOutlined), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(MenuUnfoldOutlined), { key: 1 }))
              ])
            ])
          ]),
          _: 1
        }, 8, ["collapsed"]),
        _createVNode(_component_a_layout_content, { style: { margin: '16px', padding: '24px', background: '#fff', minHeight: '280px' } }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})